import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_PRATICA } from '../../data.const';
import {
  retrievePraticaListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deletePraticaEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_PRATICA),
    map(({ payload: { ids, isCestino, ...rest } }: any) => ({
      body: {
        ids,
        isCestino,
      },
      listBody: { ...rest, isCestino },
    })),
    // tap(p => console.log(`[epic ${DELETE_PRATICA}]`, p)),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ praticaLoader: true })),
        defer(() =>
          from(
            request({ path: `pratica`, method: httpMethods.DELETE, body })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            // tap(p => console.log(`[epic ${DELETE_PRATICA}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(() => of(retrievePraticaListAction(listBody))),
            catchError(err => {
              console.error(`[epic ${DELETE_PRATICA}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ praticaLoader: false }))
      );
    })
  );

export default deletePraticaEpic;
